import React, {Component} from 'react';
import { Segment, Header, Grid, Loader } from 'semantic-ui-react';
import _ from 'underscore';
import { connect } from 'react-redux';

import FormsHradminEmployeeUpdateAccessForm from '../../../component/forms/hradmin/employee/update_access';
import {
    submitHradminEmployeeUpdateAccess
} from '../../../actions';

class HradminEmployeeViewAccessPage extends Component {
    state = {
        employeeData: null
    }
    componentDidMount() {
        // console.log(this.props);
        const {uuid} = this.props.match.params;
        // console.log(uuid);
        const selectedEmployeeData = _.find(this.props.employeelistData, (employee) => employee.uuid === uuid);
        // console.log(selectedEmployeeData);
        this.setState({employeeData: selectedEmployeeData});
    }
    render() {
        if (!this.state.employeeData) { return <Loader active /> }
        const {uuid} = this.props.match.params;
        return (
            <Grid columns={1}>
                <Grid.Column>
                    <Header block attached="top">
                        User Access
                    </Header>
                    <Segment attached>
                        <FormsHradminEmployeeUpdateAccessForm
                            user={this.props.user}
                            submitHradminEmployeeUpdateAccess={this.props.submitHradminEmployeeUpdateAccess}
                            targetUuid={uuid}
                            selectedUserRole={this.state.employeeData.roles}
                        />
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return { 
        user: state.user.user,
        employeelistData: state.hradmin.employeelistData,
    };
}

export default connect(mapStateToProps, {
    submitHradminEmployeeUpdateAccess,
})(HradminEmployeeViewAccessPage);